var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-height bg-f2 pad10-t pad10-lr" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 18 } }, [
            _c(
              "div",
              { staticClass: "radius20 pad20 h180 bg-white overflow" },
              [
                _c("h2", { staticClass: "flex justify-between" }, [
                  _c(
                    "div",
                    { staticClass: "f18 fb gray3" },
                    [
                      _vm._v("\n            标书交易数据\n            "),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-plus",
                          attrs: { type: "text", icon: "el-icon-refresh" },
                          on: { click: _vm.handleRefresh }
                        },
                        [_vm._v("刷新")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex items-center" },
                    [
                      _vm.collectInfo.publishBidUrl
                        ? _c("img", {
                            staticClass: "mar5_r",
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { src: require("./images/icon-plus.png") }
                          })
                        : _vm._e(),
                      _vm.collectInfo.publishBidUrl
                        ? _c(
                            "el-button",
                            {
                              staticClass: "btn-plus",
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.openUrl(_vm.collectInfo)
                                }
                              }
                            },
                            [_vm._v(" 创建标书")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "flex justify-between" },
                  _vm._l(_vm.collectInfo.bidDataList, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "flex justify-between items-center pad20 card1 mar10_r",
                        class: [item.havePermission != 1 ? "opacity3" : ""],
                        on: {
                          click: function($event) {
                            return _vm.handelUrl(item)
                          }
                        }
                      },
                      [
                        _c("div", [
                          _c("div", { staticClass: "f30 gray3" }, [
                            _vm._v(_vm._s(item.amount))
                          ]),
                          _c("div", { staticClass: "f14 gray6" }, [
                            _vm._v(_vm._s(item.typeCn))
                          ])
                        ]),
                        _c("el-image", {
                          staticStyle: { width: "52px", height: "52px" },
                          attrs: { src: item.icon, fit: "fill" }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            ),
            _c("div", { staticClass: "flex justify-between" }, [
              _c("div", { staticClass: "h160 relative w49" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "radius20 pad20 bg-white mar18_t overflow popover",
                    class: [_vm.isMouseMenu ? "show_card" : ""]
                  },
                  [
                    _c("h2", { staticClass: "f18 fb gray3 mar20-b" }, [
                      _vm._v("交易管理")
                    ]),
                    _c("div", { staticClass: "flex justify-between" }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex justify-between w100 popover_div",
                          on: {
                            mouseover: function($event) {
                              _vm.isMouseMenu = true
                            },
                            mouseleave: function($event) {
                              _vm.isMouseMenu = false
                            }
                          }
                        },
                        _vm._l(
                          _vm.isMouseMenu
                            ? _vm.userMenuList
                            : _vm.userMenuList.slice(0, 2),
                          function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "flex card3 mar10_r",
                                class: [
                                  item.havePermission != 1 ? "opacity3" : ""
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.handelUrl(item)
                                  }
                                }
                              },
                              [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "52px",
                                    height: "52px"
                                  },
                                  attrs: { src: item.icon, fit: "fill" }
                                }),
                                _c("div", { staticClass: "mar20-l info" }, [
                                  _c("div", { staticClass: "f20 fb gray3" }, [
                                    _vm._v(_vm._s(item.menuName))
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "f14 gray3 sub_title ellipsis2"
                                    },
                                    [_vm._v(_vm._s(item.subTitle))]
                                  )
                                ])
                              ],
                              1
                            )
                          }
                        ),
                        0
                      )
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "h160 relative w49" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "radius20 pad20 bg-white mar18_t overflow popover",
                    class: [_vm.isMouseBid ? "show_card" : ""]
                  },
                  [
                    _c("h2", { staticClass: "f18 fb gray3 mar20-b" }, [
                      _vm._v("报表管理")
                    ]),
                    _c("div", { staticClass: "flex justify-between" }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex justify-between w100 popover_div",
                          on: {
                            mouseover: function($event) {
                              _vm.isMouseBid = true
                            },
                            mouseleave: function($event) {
                              _vm.isMouseBid = false
                            }
                          }
                        },
                        _vm._l(
                          _vm.isMouseBid
                            ? _vm.bidList
                            : _vm.bidList.slice(0, 2),
                          function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "flex card3 mar10_r",
                                class: [
                                  item.havePermission != 1 ? "opacity3" : ""
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.handelUrl(item)
                                  }
                                }
                              },
                              [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "52px",
                                    height: "52px"
                                  },
                                  attrs: { src: item.icon, fit: "fill" }
                                }),
                                _c("div", { staticClass: "mar20-l info" }, [
                                  _c("div", { staticClass: "f20 fb gray3" }, [
                                    _vm._v(_vm._s(item.menuName))
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "f14 gray3 sub_title ellipsis2"
                                    },
                                    [_vm._v(_vm._s(item.subTitle))]
                                  )
                                ])
                              ],
                              1
                            )
                          }
                        ),
                        0
                      )
                    ])
                  ]
                )
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              {
                staticClass:
                  "flex flex-column justify-center items-center radius20 bg-white code"
              },
              [
                _c("el-image", {
                  staticStyle: { width: "170px", height: "170px" },
                  attrs: { src: _vm.miniQrCodeUrl, fit: "fill" }
                }),
                _c("span", { staticClass: "f14 color-7f mar30-t" }, [
                  _vm._v("扫码打开/分享小程序")
                ])
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "pad10-lr", attrs: { gutter: 20 } },
        _vm._l(_vm.tList, function(pre, index) {
          return _c(
            "div",
            { key: index, staticClass: "radius20 pad20 bg-white mar20_t" },
            [
              _c("h2", { staticClass: "f18 fb gray3 mar20-b" }, [
                _vm._v(_vm._s(pre.tags))
              ]),
              _c(
                "div",
                { staticClass: "flex flex-wrap" },
                _vm._l(pre.child, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "flex card2 pad20_tb mar10_r mar30-b",
                      class: [item.havePermission != 1 ? "opacity3" : ""],
                      on: {
                        click: function($event) {
                          return _vm.handelUrl(item)
                        }
                      }
                    },
                    [
                      _c("el-image", {
                        staticStyle: { width: "52px", height: "52px" },
                        attrs: { src: item.icon, fit: "fill" }
                      }),
                      _c("div", { staticClass: "mar20-l info" }, [
                        _c("div", { staticClass: "f20 fb gray3" }, [
                          _vm._v(_vm._s(item.menuName))
                        ]),
                        _c(
                          "div",
                          { staticClass: "f14 gray3 sub_title ellipsis2" },
                          [_vm._v(_vm._s(item.subTitle))]
                        )
                      ])
                    ],
                    1
                  )
                }),
                0
              )
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }